import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BackspaceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"backspace"}/>
}
